import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { CRITERIA_GROUP } from '../../common/constant'
import { selectIsLoadingSomeData } from '../../common/store/slice'
import { selectSelectedIndicatorCount } from '../store/slice'
import { ClearAll } from './ClearAll'
import { CriteriaGroup } from './criteriaGroup'
import classes from './index.module.scss'
import { SaveCriteria } from './SaveCriteria'
import { TotalResult } from './TotalResult'

export const MainContent = () => {
  const isLoading = useSelector(selectIsLoadingSomeData)
  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)

  const renderEmptyCriteria = () => {
    return (
      <Element
        className="textCenter mt5 pt5 fw500"
        style={{ fontSize: 20, color: '#9C9C9C' }}
      >
        <Translate value="screening.EMPTY_CRITERIA_MESS" />
      </Element>
    )
  }

  const renderCriteriaGroups = () => {
    return Object.keys(CRITERIA_GROUP).map((criteriaGroup) => (
      <CriteriaGroup key={criteriaGroup} criteriaGroup={criteriaGroup} />
    ))
  }

  return (
    <Element className={classes.mainContent}>
      <Element
        className={classes.header}
        style={{ backgroundColor: '#D5D5D5' }}
      >
        <TotalResult />
        <Element
          className="dFlex gap3 cursorPointer"
          style={{ color: '#2C73E8' }}
        >
          <SaveCriteria />
          <ClearAll />
        </Element>
      </Element>

      <Element className="flex1 minH0" id={'MainContent'}>
        <ScrollComponent>
          <Element className={classes.criteriaGroupList}>
            {isLoading ? (
              <Loading />
            ) : !selectedIndicatorCount ? (
              renderEmptyCriteria()
            ) : (
              renderCriteriaGroups()
            )}
          </Element>
        </ScrollComponent>
      </Element>
    </Element>
  )
}
